import React from 'react'
import reactStamp from 'react-stamp'
import './portal.css'
import SidePanel from '../SidePanel'
import MainPanel from '../MainPanel'
import TabsPanel from '../TabsPanel'
import MediaQuery from 'react-responsive'
import Background from '../Background'

export default reactStamp(React).compose({

    render() {
        let {
            activateHome,
            activateHealth,
            activateAppointments,
            activateDevices,
            active,
            setName
        } = this.props;

        return (
            <div>
                <Background />
                <MediaQuery minWidth={500}>
                    <div className="portal-container">
                        <SidePanel
                            active={active}
                            activateHome={activateHome}
                            activateHealth={activateHealth}
                            activateAppointments={activateAppointments}
                            activateDevices={activateDevices}
                        />
                        <MainPanel
                            active={active} setName={setName}
                        />
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={500}>
                    <div className="mobile-portal-container">
                        <TabsPanel
                            active={active}
                            activateHome={activateHome}
                            activateHealth={activateHealth}
                            activateAppointments={activateAppointments}
                            activateDevices={activateDevices}
                        />
                        <MainPanel
                            active={active} setName={setName}
                        />
                    </div>
                </MediaQuery>

            </div>
        );
    }

});



/** WEBPACK FOOTER **
 ** ./src/app/components/Portal/index.js
 **/